
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"
import EvaluationParameter, { IGetEvaluationParameterDto } from "./EvaluationParameter"

export interface IGetEvaluationParametersDto {
    entities: IGetEvaluationParameterDto[]
    links?: IApiLink[]
}

export interface IGetEvaluationParametersParams {
    assetCategoryId?: Guid
    divisionId?: Guid
}

export default class EvaluationParameters {
    list: EvaluationParameter[]
    linkCreate?: IApiLink
    linkGetAssetTypes?: IApiLink
    linkGetAssetCategoriesAndDivisions?:IApiLink

    constructor({
        entities,
        links,
    }: IGetEvaluationParametersDto) {
        this.list = entities.map(dto => new EvaluationParameter(dto))

        if (links) {
            this.linkCreate = links.find(lnk => lnk.entity === ApiLinkEntity.evaluationParameter && lnk.rel === ApiLinkRel.new)
            this.linkGetAssetTypes = links.find(lnk => lnk.entity === ApiLinkEntity.assetType && lnk.rel === ApiLinkRel.all)
            this.linkGetAssetCategoriesAndDivisions = links.find(lnk => lnk.entity === ApiLinkEntity.assetCategoriesAndDivisions && lnk.rel === ApiLinkRel.all)
        }
    }

    get canCreate(): boolean {
        return !!this.linkCreate
    }
}
